import { useTranslations } from '@prosaas/psw-utils';
import { translationsService } from '../services/translationsService';
import type { ITranslationsAuth } from '../translations/translations.interface';

export const useAuthTranslations = () =>
  useTranslations(translationsService) as unknown as [
    translations: ITranslationsAuth,
    isLoadingTranslations: boolean,
  ];
